import React, { Component } from 'react';
import Button from '../form/Button';
import moment from 'moment';
import AuthService from '../../state/auth.service';
import CommentApi from '../../api/comment/index';
import ExpandingTextArea from '../form/ExpandingTextArea';

class CommentsCard extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            comments: this.props.comments || [],
            newCommentBody: '',
            updatedCommentBodies: {},
            editIdsInProgress: [],
        };

        this.removeDomain = this.removeDomain.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleUpdateTextChange = this.handleUpdateTextChange.bind(this);
        this.handleUpdateKeyDown = this.handleUpdateKeyDown.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.startEdit = this.startEdit.bind(this);
        this.filterInPlace = this.filterInPlace.bind(this);
    }

    filterInPlace(a, condition, thisArg) {
        let j = 0;

        a.forEach((e, i) => {
            if (condition.call(thisArg, e, i, a)) {
                if (i !== j) a[j] = e;
                j++;
            }
        });

        a.length = j;
        return a;
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
        this.setState({
            comments: nextProps.comments,
        });
    }

    handleTextChange(event) {
        this.setState({
            newCommentBody: event.target.value,
        });
    }

    handleKeyDown(event) {
        if (event.key === 'Enter') {
            //enter key:
            this.handleAdd(event);
        }
    }

    handleUpdateTextChange(event, commentId) {
        var updatedCommentBody = {};
        updatedCommentBody[commentId] = event.target.value;
        this.setState({
            updatedCommentBodies: Object.assign(
                this.state.updatedCommentBodies,
                updatedCommentBody
            ),
        });
    }

    handleUpdateKeyDown(event, commentId) {
        if (event.key === 'Enter') {
            //enter key:
            this.handleUpdate(event, commentId);
        }
    }

    removeDomain(user_email) {
        return user_email.split('@')[0];
    }

    handleAdd(event) {
        event.preventDefault();
        let userEmail = AuthService.getUser().email;
        let newCommentBody = this.state.newCommentBody;
        CommentApi.create(
            this.props.criterionId,
            userEmail,
            newCommentBody
        ).then(comment => {
            this.state.comments.push(comment);
            this.setState({
                newCommentBody: '',
                comments: this.state.comments,
            });
        });
    }

    startEdit(event, commentId) {
        event.preventDefault();
        var updatedCommentBody = {};
        updatedCommentBody[commentId] = this.filterInPlace(
            this.state.comments,
            comment => comment.id === commentId
        )[0].body;
        this.setState({
            editIdsInProgress: [...this.state.editIdsInProgress, commentId],
            updatedCommentBodies: Object.assign(
                this.state.updatedCommentBodies,
                updatedCommentBody
            ),
        });
    }

    handleUpdate(event, commentId) {
        event.preventDefault();
        let updatedCommentBody = this.state.updatedCommentBodies[commentId];
        CommentApi.update(
            this.props.criterionId,
            commentId,
            updatedCommentBody
        ).then(updatedComment => {
            let comments = this.filterInPlace(
                this.state.comments,
                comment => comment.id !== commentId
            );
            let commentBodies = {};
            comments.map(comment => {
                commentBodies[comment.id] = comment.body;
                return null; // linter
            });
            comments.push(updatedComment);
            this.setState({
                editIdsInProgress: this.state.editIdsInProgress.filter(
                    id => id !== commentId
                ),
                updatedCommentBodies: commentBodies,
                comments: comments,
            });
        });
    }

    handleRemoval(event, commentId) {
        event.preventDefault();
        CommentApi.remove(this.props.criterionId, commentId)
            .then(() => {
                let comments = this.filterInPlace(
                    this.state.comments,
                    comment => comment.id !== commentId,
                    this
                );
                this.setState({ comments: comments });
            })
            .catch(err => {
                console.log(err);
            });
    }

    render() {
        return (
            <div className="Comment__panel">
                <div className="Comments">
                    {this.state.comments.map(comment => {
                        return (
                            <div key={comment.id}>
                                <div className="Comment">
                                    <div className="Comment-text">
                                        <div className="Metadata">
                                            {this.removeDomain(
                                                comment.user_email
                                            )}
                                            ,{' '}
                                            {moment(comment.created_at).format(
                                                'M/D/YYYY HH:mmA'
                                            )}{' '}
                                            :
                                        </div>
                                        {this.state.editIdsInProgress.includes(
                                            comment.id
                                        ) ? (
                                            <input
                                                className="Comment-input"
                                                type="text"
                                                value={
                                                    this.state
                                                        .updatedCommentBodies[
                                                        comment.id
                                                    ]
                                                }
                                                onChange={e => {
                                                    this.handleUpdateTextChange(
                                                        e,
                                                        comment.id
                                                    );
                                                }}
                                                onKeyDown={e => {
                                                    this.handleUpdateKeyDown(
                                                        e,
                                                        comment.id
                                                    );
                                                }}
                                            />
                                        ) : (
                                            <div className="Content">
                                                {comment.body}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Buttons-wrapper">
                                        {/* 
                                        DEPRECATED
                                        There is a bug where the rest of the comments in 
                                        the list disapear when you edit / update. Also 
                                        we do not want the ability to modify the history.
                                        */}
                                        {/* {comment.user_email ===
                                            AuthService.getUser().email &&
                                        !this.state.editIdsInProgress.includes(
                                            comment.id
                                        ) ? (
                                            <Button
                                                icon="fa-pencil"
                                                size="small"
                                                onClick={e => {
                                                    this.startEdit(
                                                        e,
                                                        comment.id
                                                    );
                                                }}
                                            />
                                        ) : null}
                                        {this.state.editIdsInProgress.includes(
                                            comment.id
                                        ) ? (
                                            <Button
                                                size="small"
                                                defaultText="Update"
                                                onClick={e => {
                                                    this.handleUpdate(
                                                        e,
                                                        comment.id
                                                    );
                                                }}
                                            />
                                        ) : null} */}
                                        {comment.user_email ===
                                        AuthService.getUser().email ? (
                                            <Button
                                                icon="fa-trash"
                                                size="small"
                                                onClick={e => {
                                                    this.handleRemoval(
                                                        e,
                                                        comment.id
                                                    );
                                                }}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                                <hr />
                            </div>
                        );
                    })}
                </div>
                <ExpandingTextArea
                    type="text"
                    value={this.state.newCommentBody}
                    onChange={this.handleTextChange}
                    onKeyDown={this.handleKeyDown}
                />

                <div className="CommentBtn">
                    <Button
                        defaultText="Add Comment"
                        busyText="..."
                        onClick={this.handleAdd}
                    />
                </div>
            </div>
        );
    }
}

export default CommentsCard;
